import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import CheckoutPage from "@/pages/CheckoutPage";
import PayPage from "@/pages/PayPage";

function App() {
  return (
    <div className="App">
      {/* Background layers */}
      <div className="tech-grid" data-testid="tech-grid-bg" />
      <div className="scan-lines" />

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CheckoutPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/pay/:txId" element={<PayPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#0a0d0c",
            border: "1px solid rgba(0,255,136,0.25)",
            color: "#e6fff2",
          },
        }}
      />
    </div>
  );
}

export default App;
